module.exports = "<p>\n  available-products works!\n</p>\n"